// LIST
export const FETCH_HOME_GROUP_STAFFS =
  "app/HomeGroupsStaff/FETCH_HOME_GROUP_STAFFS";
export const FETCH_HOME_GROUP_STAFFS_SUCCESS =
  "app/HomeGroupsStaff/FETCH_HOME_GROUP_STAFFS_SUCCESS";
export const FETCH_HOME_GROUP_STAFFS_FAILURE =
  "app/HomeGroupsStaff/FETCH_HOME_GROUP_STAFFS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/HomeGroupsStaff/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS =
  "app/HomeGroupsStaff/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE =
  "app/HomeGroupsStaff/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_HOME_GROUP_STAFF = "app/HomeGroupsStaff/ADD_HOME_GROUP_STAFF";
export const ADD_HOME_GROUP_STAFF_SUCCESS =
  "app/HomeGroupsStaff/ADD_HOME_GROUP_STAFF_SUCCESS";
export const ADD_HOME_GROUP_STAFF_FAILURE =
  "app/HomeGroupsStaff/ADD_HOME_GROUP_STAFF_FAILURE";
// EDIT
export const EDIT_HOME_GROUP_STAFF =
  "app/HomeGroupsStaff/EDIT_HOME_GROUP_STAFF";
export const EDIT_HOME_GROUP_STAFF_SUCCESS =
  "app/HomeGroupsStaff/EDIT_HOME_GROUP_STAFF_SUCCESS";
export const EDIT_HOME_GROUP_STAFF_FAILURE =
  "app/HomeGroupsStaff/EDIT_HOME_GROUP_STAFF_FAILURE";
// DELETE
export const DELETE_HOME_GROUP_STAFF =
  "app/HomeGroupsStaff/DELETE_HOME_GROUP_STAFF";
export const DELETE_HOME_GROUP_STAFF_SUCCESS =
  "app/HomeGroupsStaff/DELETE_HOME_GROUP_STAFF_SUCCESS";
export const DELETE_HOME_GROUP_STAFF_FAILURE =
  "app/HomeGroupsStaff/DELETE_HOME_GROUP_STAFF_FAILURE";
//
export const OPEN_STAFF_ADD_MODAL = "app/HomeGroupsStaff/OPEN_STAFF_ADD_MODAL";
export const CLOSE_STAFF_ADD_MODAL =
  "app/HomeGroupsStaff/CLOSE_STAFF_ADD_MODAL";
//
export const OPEN_STAFF_EDIT_MODAL =
  "app/HomeGroupsStaff/OPEN_STAFF_EDIT_MODAL";
export const CLOSE_STAFF_EDIT_MODAL =
  "app/HomeGroupsStaff/CLOSE_STAFF_EDIT_MODAL";
